import { QuoteStore } from "./types";

export const defaultState: QuoteStore = {
  quote: undefined,
  loading: false,
};
